/* eslint-disable no-useless-escape */
/* eslint-disable import/no-webpack-loader-syntax */
import React from 'react'
import { Code } from 'rebass'

import Command from '../components/Command'
import Heading from '../components/Heading'
import P from '../components/P'
import SH from '../components/SH'
import Theory from '../components/Theory'
import Toc from '../components/Toc'
import ButtonLink from '../components/ButtonLink'
import Discuss from '../components/Discuss'
import Lost from '../components/Lost'

const Speed = () => (
  <div>
    <Toc active="speed" />
    <Heading fontSize={7}>Speed</Heading>
    <Theory>
      <P>Let's talk about having an external renderer.</P>
    </Theory>
    <P>
      Add this node renderer into <Code>node-renderer.js</Code>:
    </P>
    <SH
      language="javascript"
      code={`
var net = require("net");
var fs = require("fs");
var path = require("path");

var bundlePath = "./var/webpack/";
var bundleFileName = "app.js";

var currentArg;

function Handler() {
  this.queue = [];
  this.initialized = false;
}


Handler.prototype.handle = function(connection) {

  var callback = function () {
      connection.setEncoding('utf8');
  
      let data = [];
      let lastChar;
      connection.on('data', (chunk)=> {
          data.push(chunk);
          lastChar = chunk.substr(chunk.length - 1);
  
          if(lastChar === '\\0') {
            data = data.join('');
            let result = eval(data.slice(0, -1));
            connection.write(result);
            console.log("Request processed");
            connection.end();
          }
      });
  };
  if (this.initialized) {
    callback();
  } else {
    this.queue.push(callback);
  }
};

Handler.prototype.initialize = function() {
  console.log("Processing " + this.queue.length + " pending requests");
  var callback = this.queue.pop();
  while (callback) {
    callback();
    callback = this.queue.pop();
  }

  this.initialized = true;
};

var handler = new Handler();

process.argv.forEach(val => {
  if (val[0] == "-") {
    currentArg = val.slice(1);
    return;
  }

  if (currentArg == "s") {
    bundleFileName = val;
  }
});

try {
  fs.mkdirSync(bundlePath);
} catch (e) {
  if (e.code != "EEXIST") throw e;
}

require(bundlePath + bundleFileName);
console.log("Loaded server bundle: " + bundlePath + bundleFileName);
handler.initialize();

fs.watchFile(bundlePath + bundleFileName, curr => {
  if (curr && curr.blocks && curr.blocks > 0) {
    if (handler.initialized) {
      console.log(
        "Reloading server bundle must be implemented by restarting the node process!"
      );
      return;
    }

    require(bundlePath + bundleFileName);
    console.log("Loaded server bundle: " + bundlePath + bundleFileName);
    handler.initialize();
  }
});

var unixServer = net.createServer(function(connection) {
  handler.handle(connection);
});

unixServer.listen("var/node.sock");

process.on("SIGINT", () => {
  unixServer.close();
  process.exit();
});
      
    `}
    />
    <P>
      And change the configuration of React Bundle to use it in{' '}
      <Code>config/packages/limenius-react.yaml</Code>:
    </P>
    <SH
      language="yaml"
      code={`
limenius_react:
    default_rendering: "both"

    serverside_rendering:
        trace: true
        fail-loud: true
        mode: "external_server"
        server_bundle_path: "%kernel.project_dir%/var/webpack/app.js"
        server_socket_path: "%kernel.project_dir%/var/node.sock"
    `}
    />

    <P>And run it in a new terminal:</P>
    <Command>node node-renderer.js</Command>
    <Discuss>
      <P>Can you notice the difference in speed?</P>
      <P>
        Change from <Code>external_server</Code> to <Code>phpexecjs</Code> back
        and forth and check the debug toolbar of Symfony.
      </P>
    </Discuss>
    <Lost tag="07-speed" />
  </div>
)

export default Speed



// WEBPACK FOOTER //
// ./src/pages/speed.js